import enabledGoogleTwoFactor from './enabledGoogleTwoFactorAuth';
import verifyToken from './verifyToken';
import disableGoogleTwoFactorAuth from './disableGoogleTwoFactorAuth';

export default {
  enabledGoogleTwoFactor,
  verifyToken,
  disableGoogleTwoFactorAuth,
};



// WEBPACK FOOTER //
// ./src/app/services/googleTwoFactorAuthSetup/index.js